
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const CollectFeeList = createAsyncThunk('staff-list', async (searchParams) => {
    let res = await dataService.GetAPI(searchParams);
    return res
})
const CollectFeeSlice = createSlice({

    name: 'CollectFeeList-list',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        }

    },
    extraReducers: {
        [CollectFeeList.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [CollectFeeList.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [CollectFeeList.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading } = CollectFeeSlice.actions;
export default CollectFeeSlice.reducer